import type { FilterData } from '@which/shared'

import type { Category } from '../Configs/categories'
import type { Option } from '../QuestionScreen/QuestionScreen'
import {
  budgetQuestionsAndFilters,
  osQuestionsAndFilters,
  usecaseQuestionsAndFilters,
} from './LaptopQuestionsConfig'
import {
  mattressAchesPainsQuestion,
  mattressBudgetQuestion,
  mattressFirmnessQuestion,
  mattressGreenChoiceQuestion,
  mattressPartnerMovementQuestion,
  mattressPartnerSleepPositionQuestion,
  mattressRemovableCoverQuestion,
  mattressShareBedQuestion,
  mattressSleepPositionQuestion,
  mattressTemperaturePreferenceQuestion,
  mattressTypeQuestion,
  mattressWeightDifferenceQuestion,
} from './MattressQuestionsConfig'

type CAPIJsonValue = string | number | boolean | null | CAPIJsonObject | CAPIJsonValue[]

type CAPIJsonObject = {
  [key: string]: CAPIJsonValue
}

type CAPIFilterData = CAPIJsonObject

export type QuestionConfig<Questions extends string> = {
  name: Questions
  title?: string
  question: string
  shortQuestion: string // used for analytics
  required?: boolean
  options: (Option & {
    filter?: FilterData | CAPIFilterData
    skipSteps?: Questions[]
  })[]
}

export const questionConfigsByCategory: Record<Category, QuestionConfig<string>[]> = {
  laptops: [budgetQuestionsAndFilters, osQuestionsAndFilters, usecaseQuestionsAndFilters],
  mattresses: [
    mattressBudgetQuestion,
    mattressTypeQuestion,
    mattressShareBedQuestion,
    mattressSleepPositionQuestion,
    mattressPartnerSleepPositionQuestion,
    mattressPartnerMovementQuestion,
    mattressWeightDifferenceQuestion,
    mattressFirmnessQuestion,
    mattressAchesPainsQuestion,
    mattressTemperaturePreferenceQuestion,
    mattressRemovableCoverQuestion,
    mattressGreenChoiceQuestion,
  ],
}
